import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _isEmpty from 'lodash/isEmpty';
import queryParser from 'querystring';
import { createIntl, createIntlCache } from 'react-intl';
import { IntlErrorCode } from '@formatjs/intl';
var EN_LOCALE = 'en-US';
var FALLBACK_LANG = EN_LOCALE;
var CDN_URL = 'https://static.guesty.com';
var LOCALIZATION_FOLDER = 'i18n';
var legacyKeysToLocaleMapping = {
  cs: 'cs-CZ',
  // Czech
  da: 'da-DK',
  // Danish
  de: 'de-DE',
  // German
  el: 'el-GR',
  // Greek
  en: 'en-US',
  // English
  es: 'es-ES',
  // Spanish
  fr: 'fr-FR',
  // French
  hr: 'hr-HR',
  // Croatian
  hu: 'hu-HU',
  // Hungarian
  it: 'it-IT',
  // Italian
  ja: 'ja-JP',
  // Japanese
  ko: 'ko-KR',
  // Korean
  nl: 'nl-NL',
  // Dutch
  pl: 'pl-PL',
  // Polish
  pt: 'pt-PT',
  // Portuguese
  ru: 'ru-RU',
  // Russian
  sk: 'sk-SK',
  // Slovak
  zh: 'zh-CN' // Chinese

};
export var getLocaleJsonURL = function getLocaleJsonURL(lang) {
  var language = legacyKeysToLocaleMapping[lang] || lang;
  return "".concat(CDN_URL, "/").concat(LOCALIZATION_FOLDER, "/").concat(language, ".json");
};
export var getLanguage = function getLanguage() {
  try {
    var query = window.location.search.split('?');
    var queryLang;

    if (query.length >= 2) {
      var params = queryParser.parse(query[1]);
      queryLang = params && params.lang ? params.lang : undefined;
    }

    return queryLang || window.localStorage.getItem('lang') || FALLBACK_LANG;
  } catch (e) {
    console.error(e);
    return FALLBACK_LANG;
  }
};

var handleOnIntlError = function handleOnIntlError(_ref) {
  var debug = _ref.debug;
  return function (e) {
    if (e && e.code === IntlErrorCode.MISSING_TRANSLATION) {
      if (debug) {
        console.log('Missing translation:', e.message);
      }
    } else {
      console.error(e);
    }
  };
};

var Intl = /*#__PURE__*/function () {
  // @ts-ignore
  // @ts-ignore
  function Intl() {
    _classCallCheck(this, Intl);

    this.formatJsIntl = void 0;
    this.initialized = void 0;

    if (Intl.instance == null) {
      try {
        this.formatJsIntl = createIntl({
          locale: FALLBACK_LANG,
          messages: {},
          onError: handleOnIntlError({
            debug: false
          })
        }, createIntlCache());
      } catch (e) {
        console.error("[Localize] Failed to initialize with lang ".concat(FALLBACK_LANG), e);
      }

      this.initialized = false;
      Intl.instance = this;
    }

    return Intl.instance;
  }

  _createClass(Intl, [{
    key: "getIntl",
    value: function getIntl() {
      return this.formatJsIntl;
    }
  }, {
    key: "init",
    value: function init(_ref2) {
      var _ref2$language, lang, onError, onLoad, translations, debug, language, url, data, res, cache;

      return _regeneratorRuntime.async(function init$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2$language = _ref2.language, lang = _ref2$language === void 0 ? FALLBACK_LANG : _ref2$language, onError = _ref2.onError, onLoad = _ref2.onLoad, translations = _ref2.translations, debug = _ref2.debug;
              _context.prev = 1;
              language = legacyKeysToLocaleMapping[lang] || lang;
              url = getLocaleJsonURL(language);

              if (!(translations && !_isEmpty(translations))) {
                _context.next = 9;
                break;
              }

              if (debug) {
                console.log('[Localize] Using translations data from props. Skipping fetch request to CDN.');
              }

              data = translations;
              _context.next = 21;
              break;

            case 9:
              if (!(language === EN_LOCALE)) {
                _context.next = 14;
                break;
              }

              if (debug) {
                console.log('[Localize] Using default english strings. Skipping fetch request of json file...');
              }

              data = {};
              _context.next = 21;
              break;

            case 14:
              _context.next = 16;
              return _regeneratorRuntime.awrap(fetch(url));

            case 16:
              res = _context.sent;
              _context.next = 19;
              return _regeneratorRuntime.awrap(res.json());

            case 19:
              data = _context.sent;

              if (debug) {
                console.log("[Localize] translations received from server for locale ".concat(language, ":"));
                console.log(data);
              }

            case 21:
              cache = createIntlCache();
              this.formatJsIntl = createIntl({
                locale: language || FALLBACK_LANG,
                messages: data || {},
                onError: handleOnIntlError({
                  debug: debug
                })
              }, cache);
              this.initialized = true;

              if (data) {
                onLoad === null || onLoad === void 0 ? void 0 : onLoad();
              } else {
                console.error('[Localize Error] No translations received from server. Will fallback to default messages.');
              }

              return _context.abrupt("return", {
                intl: this.formatJsIntl
              });

            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](1);
              onError === null || onError === void 0 ? void 0 : onError(_context.t0);
              console.error('[Localize Error] Intl init failed with error:\n', _context.t0);
              return _context.abrupt("return", {
                intl: undefined
              });

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[1, 28]]);
    }
    /*
     * Removed the following methods as they are formatting the date and time
     * based on UTC time.
     * This causes issues when the user is in a different timezone then the
     * property's timezone.
     *
     * Related threads:
     * https://guesty.slack.com/archives/C03PLG9K91D/p1676798022194539
     *
     * https://guesty.slack.com/archives/C04Q1CYD7D4/p1676796698582089
     *
     * https://guesty.atlassian.net/browse/PRO-780
     * */
    // formatDateTimeRange(from: Parameters<DateTimeFormat['formatRange']>[0], to: Parameters<DateTimeFormat['formatRange']>[1], opts?: FormatDateOptions): string;
    // formatDate(
    //   value: Parameters<Intl.DateTimeFormat['format']>[0] | string,
    //   opts?: FormatDateOptions
    // ): string {
    //   return this.formatJsIntl.formatDate(value, opts);
    // }
    // formatTime(
    //   value: Parameters<Intl.DateTimeFormat['format']>[0] | string,
    //   opts?: FormatDateOptions
    // ): string {
    //   return this.formatJsIntl.formatTime(value, opts);
    // }
    // formatRelativeTime(
    //   value: Parameters<Intl.RelativeTimeFormat['format']>[0],
    //   unit?: Parameters<Intl.RelativeTimeFormat['format']>[1],
    //   opts?: FormatRelativeTimeOptions
    // ): string {
    //   return this.formatJsIntl.formatRelativeTime(value, unit, opts);
    // }

  }, {
    key: "formatNumber",
    value: function formatNumber(value, opts) {
      return this.formatJsIntl.formatNumber(value, opts);
    }
  }, {
    key: "formatMessage",
    value: function formatMessage(descriptor, values, opts) {
      try {
        return this.formatJsIntl.formatMessage(descriptor, values, opts);
      } catch (e) {
        console.error(e);
        return descriptor.defaultMessage || descriptor.id || '';
      }
    }
  }]);

  return Intl;
}();

Intl.instance = void 0;
var intl = new Intl();
export { FALLBACK_LANG, CDN_URL, LOCALIZATION_FOLDER };
export default intl;